import script from "./footer.vue?vue&type=script&setup=true&lang=js"
export * from "./footer.vue?vue&type=script&setup=true&lang=js"

import "./footer.vue?vue&type=style&index=0&id=23505e2b&scoped=true&lang=css"

import exportComponent from "G:\\work\\快创\\不凡商城\\aliyun\\bf-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23505e2b"]])

export default __exports__